import styled from "styled-components";

export const Container = styled.div`
  background-color: var(--lisa-background);
  display: flex;
  padding: 0 10% 0;
  flex-direction: column;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 90%;
  color: var(--white);

  p {
    font-weight: 400;
    margin-top: 7.81px;
    margin-bottom: 11.19px;
    font-size: 4.375em;

    @media (max-width: 768px) {
      font-size: 3.125em;
    }
  }

  span {
    margin-bottom: 54px;
    font-family: Roboto;
    font-size: 1.25em;
    font-weight: 400;
    letter-spacing: 0em;
    text-align: center;
  }

  button {
    height: 60px;
    width: 142px;
    border: 0px;
    border-radius: 2px;
    background-color: var(--white);
    font-size: 1.375em;
    color: var(--blue);
    transition: filter 0.2s;

    &:hover {
      filter: brightness(0.9);
    }
  }

  @media (max-width: 390px) {
    p {
      font-size: 2.813em;
    }
  }
`;
